<template>
  <div class="report-types">
    <div class="text-center">
      <h3 class="q-pa-md text-grey-5">Start building report</h3>
    </div>

    <q-spinner v-if="!reportTypes" class="spinner" color="primary" size="2.5em" />

    <div v-else class="report-types-list">
      <q-btn
        v-for="reportType of reportTypes"
        :key="reportType.id"
        :label="reportType.name"
        :to="`/reports/${reportType.slug}/new`"
        class="report-list-item"
        outline
        color="teal-4"
      />
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  computed: {
    ...mapState('reports', ['reportTypes'])
  },

  created() {
    this.setRouterView('startingPage')
    this.setActiveToolbar('savedReports')
  },

  methods: {
    ...mapMutations('reports', ['setRouterView', 'setActiveToolbar'])
  }
}
</script>

<style lang="stylus" scoped>
@import '~@/styles/stylus/custom-variables'

.report-types {
  text-align center
  display grid
  grid-template-rows 100px 1fr

  .spinner {
    justify-self center
  }

  .report-types-list {
    margin-top 20px
    display grid
    justify-content center
    align-items center
    align-content start
    gap 10px
  }

  .report-list-item {
    width 30em
  }
}
</style>
